/* eslint-disable react/prop-types */
import CustomAlert from 'components/alerts/CustomAlert';
import React, { createContext, useContext, useEffect, useState } from 'react';

const ModalContext = createContext();

const icons = {
  success: 'icon-park-outline:check-one',
  warning: 'fluent:warning-32-filled',
  info: 'heroicons-outline:information-circle',
  danger: 'radix-icons:cross-circled'
};

export const useAlert = () => useContext(ModalContext);

export const AlertModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let timer;

    if (showModal && !isHovered) {
      timer = setTimeout(() => {
        setShowModal(false);
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [showModal, isHovered]);

  const showAlert = props => {
    const { variant, message } = props;

    // Validate props
    if (!variant || !icons[variant]) {
      console.warn('Invalid alert variant provided:', variant);
      return;
    }
    if (!message) {
      console.warn('Alert message is missing');
    }

    setModalProps(props);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <ModalContext.Provider value={{ showAlert }}>
      {children}
      <CustomAlert
        show={showModal}
        handleClose={handleClose}
        icon={icons[modalProps.variant]}
        message={modalProps.message || 'Alert message not provided'}
        variant={modalProps.variant}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    </ModalContext.Provider>
  );
};

export default AlertModalProvider;
